import type { CSSProperties, FC } from "react";

import classnames from "classnames";

import { ImageBehaviour } from "@jti/core-components/components/ImageBehaviour";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";

import styles from "./ImageLink.module.scss";

export type ImageLinkProps = {
  link: string;
  src: string;
  title?: string;
  width?: number;
  height?: number;
  alt: string;
  className?: string;
  imageClassName?: string;
  objectFit?: "contain" | "cover";
  imageCustomStyles?: CSSProperties;
};

export const ImageLink: FC<ImageLinkProps> = ({
  link,
  src,
  alt,
  title,
  width,
  height,
  className,
  imageClassName,
  objectFit = "contain",
  imageCustomStyles,
}) => {
  const linkMaxSize = { maxHeight: height || "none", maxWidth: width || "none" } as CSSProperties;

  return (
    <LinkBehaviour
      href={link}
      className={classnames(styles.link, className)}
      style={linkMaxSize}
      data-testid="ImageLink"
    >
      <ImageBehaviour
        style={{ objectFit, ...linkMaxSize, ...imageCustomStyles }}
        src={src}
        alt={alt}
        title={title}
        width={width}
        height={height}
        className={classnames(styles.image, imageClassName)}
      />
    </LinkBehaviour>
  );
};
